module.exports = __webpack_public_path__ + "static/media/innova.f4d6ecf1.png";